import InfoRow from '../../../../shopping-basket/ItemCard/InfoRow';

interface IProps {
  buyerName: string;
  buyerAddress: string;
  buyerPostalCode: string;
  buyerNumber: string;
  buyerState?: string;
  buyerCity?: string;
  buyerBlockNumber: string;
}

const BuyerInformation = ({
  buyerName,
  buyerAddress,
  buyerPostalCode,
  buyerNumber,
  buyerState,
  buyerCity,
  buyerBlockNumber,
}: Partial<IProps>) => {
  const formattedAddress = `${
    buyerState && buyerCity ? buyerState + ' / ' + buyerCity : ''
  } ${buyerAddress ? ',' + buyerAddress : ''}${
    buyerBlockNumber ? ', پلاک ' + buyerBlockNumber : ''
  }`;
  return (
    <div className="space-y-2">
      <span className="text-sm font-medium text-zinc-500">اطلاعات خریدار</span>

      <div className="p-3 space-y-2 bg-zinc-100 rounded-xl">
        <InfoRow
          icon="icon-nameProfile"
          label="نام و نام خانوادگی"
          value={buyerName ?? 'مشخص نشده'}
        />
        {(buyerAddress || buyerCity || buyerState || buyerBlockNumber) && (
          <InfoRow
            icon="icon-nameLocation"
            label="آدرس گیرنده"
            value={formattedAddress}
          />
        )}

        {buyerPostalCode && (
          <InfoRow
            icon="icon-nameemail-sendng"
            label="کد پستی"
            value={buyerPostalCode}
          />
        )}
        <InfoRow icon="icon-namecall" label="شماره تماس" value={buyerNumber} />
      </div>
    </div>
  );
};

export default BuyerInformation;
